import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const info = async (data: any) => {
  return httpRequest.get(`/api/client/user_info`, data);
};
